import React, {Component} from 'react';
import AccountInvoiceContainer from '../../../containers/account_invoice_container';
import {Header, Tab} from 'semantic-ui-react';
import InvoiceEstimates from "./estimates";
import InvoiceList from "./invoices";

class Invoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: 'estimate'
        }
    }

    render() {
        const panes = [
            {menuItem: 'Estimates', render: () => <Tab.Pane><InvoiceEstimates/></Tab.Pane>},
            {menuItem: 'Invoices', render: () => <Tab.Pane><InvoiceList/></Tab.Pane>},
        ];

        return (<div style={{width: '95%', margin: 'auto'}}>
            <Header className="pad-top" content="Invoices" size="large" textAlign="left"/>
            <Tab panes={panes}/>
        </div>)
    }
}

export default AccountInvoiceContainer(Invoice);


// WEBPACK FOOTER //
// ./src/views/accounts/invoice/index.js